<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-text>
        <h3 class="headline mb-0">{{ $t("penalities.title") }}</h3>
        <v-form ref="form">
          <v-select :items="penalities" item-text="toString" item-value="id" v-model="model.penalityId" />
          <v-text-field v-model="model.amount" :label="this.$t('penalities.amount')" />
        </v-form>
        {{ this.penality ? this.penality.penalityString:"/"}}<br />
        {{ this.penality ? this.penality.additionalTime:"/"}}
      </v-card-text>
      <v-card-actions>
        <v-btn @click="this.save" color="success">
          {{ $t("ctrl.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VAlert,
    VDialog
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'

  export default {
    name: 'RunPenality',
    data: () => ({
      dialog: false,
      model: {},
      penalities: []
    }),
    computed: {
      applicationTypes: function () {
        return [this.$t("application.individual"), this.$t("application.tandem"), this.$t("application.relay")]
          .map((e, i)=>{return {id: i, name: e}})
      },
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      },
      penality: function(){
          var pid = this.model.penalityId;
          return this.penalities.filter(p => p.id == pid)[0];
      }
    },
    props: {
      source: String,
      applicationType: Number,
      reload: Function
    },
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VDataTable,
      VTextarea,
      VAutocomplete,
      VCheckbox,
      VAlert,
      VDialog
    },
    methods: {
      show: function(obj){
        this.model = JSON.parse(JSON.stringify(obj));
        this.dialog = true;
      },
      save: function(){
        if(this.model.id != undefined){
          fccapi.post(`run-penalities/${this.model.id}`, this.model).then(d => {
            this.dialog = false;
            this.reload();
          }).catch(e => {
            console.log(e)
          })
        }else{
          this.model.RunId = this.$route.params.id;
          fccapi.post(`run-penalities`, this.model).then(d => {
            this.dialog = false;
            this.reload();
          }).catch(e => {
            console.log(e)
          })
        }
      }
    },
    mounted: function(){
      fccapi.get(`runs/${this.$route.params.id}/all-penalities`).then(d => {
        this.penalities = d.data.map(a => {a.toString = a.disciplineId+" "+a.title; return a;})
      })
    }
  }
</script>